import { render, staticRenderFns } from "./wxwl.vue?vue&type=template&id=57bdca4a"
import script from "./wxwl.vue?vue&type=script&lang=js"
export * from "./wxwl.vue?vue&type=script&lang=js"
import style0 from "./wxwl.vue?vue&type=style&index=0&id=57bdca4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports